import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Floater from 'react-floater';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import InvisibleOverlay from 'components/shared/elements/invisible-overlay';

export default class MoreInfo extends Component {
  static propTypes = {
    children: PropTypes.oneOf([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element)
    ]),
    title: PropTypes.element,
    placement: PropTypes.oneOf([
      'top',
      'bottom',
      'left',
      'right',
      'auto',
      'center'
    ]),
    size: PropTypes.oneOf(['xs', 'sm', 'lg', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x'])
  };

  state = { open: false }


  onClick = () => {
    const { open } = this.state;
    this.setState({ open: !open });
  }

  render() {
    const { open } = this.state;
    const { children, title, placement, size } = this.props;
    return (
      <span>
        <Floater
          styles={{ wrapper: { marginLeft: '.5rem', marginRight: '.5rem', justifyContent: 'flex-end' }, floater: { zIndex: 1100 } }}
          content={children}
          title={title}
          placement={placement}
          disableFlip={true}
          open={open}
        >
          <FontAwesomeIcon role="button" size={size} icon="info-square" className="text-blue pointer" onClick={this.onClick} />
        </Floater>
        {open && <InvisibleOverlay onClick={this.onClick} />}
      </span>
    );
  }
}
